import React from "react";
import { graphql } from "@apollo/client/react/hoc";
import { Tender } from "ComponentsUI/Tender";
import { REGION_QUERY } from "Services/queries";
import { withRouter, Link } from "react-router-dom";
import { observer, inject } from "mobx-react";
import withDefaultParams from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import queryString from "query-string";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";
import Button from "ComponentsUI/Button";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import configRouters from "Configs/routes";
import { Helmet } from "react-helmet-async";
import { isMainSiteCode } from "Utils/siteConfig";
import { addABData, addRefererData } from "Utils";

@withRouter
@inject("ApplicationModel")
@observer
class TenderContainer extends React.Component {
	constructor(props) {
		super(props);
	}

	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(configRouters.Business.route, this.props.match.params);

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	componentWillUnmount() {
		let {
			ApplicationModel: { sendingStore, compareTarifficationsModel },
		} = this.props;
		sendingStore.setSend(false);
		compareTarifficationsModel.setWidgetIsVisible();
	}

	componentDidMount() {
		let {
			ApplicationModel: {
				compareTarifficationsModel,
				tenderAddresesModel,
				tenderAddressOneStringModel,
				searcheModel,
				searcheModelOneString,
				modalModel,
			},
		} = this.props;
		sendMetriks("OPEN_ORDER_FORM");

		if (modalModel.isOpen) {
			modalModel.toggleModal();
		}
		let one_string_search =
			this.props.ApplicationModel?.siteConfig?.settings?.one_string_search?.enabled;

		let house_id;
		if (one_string_search) {
			house_id = this.props.ApplicationModel.searcheModelOneString?.house_id;
		} else {
			house_id = this.props.ApplicationModel.searcheModel?.house_id;
		}

		let params = queryString.parse(this.props.location.search);
		if (house_id) {
			if (one_string_search) {
				tenderAddressOneStringModel.searchModels[0].findAddress(house_id);
			} else {
				tenderAddresesModel.seacheModels[0].findAddress(house_id);
			}
		}

		if (!!params.u_house) {
			if (one_string_search) {
				let currentFullAddress = searcheModelOneString.getCurrentFullAddress();
				if (!!currentFullAddress?.data?.street_id) {
					tenderAddressOneStringModel.initSearchModelByData(0, currentFullAddress);
				}
			} else {
				let currentStreet = searcheModel.getCurrentStreet();
				if (!!currentStreet && !!currentStreet.street_id) {
					let currentAddress = searcheModel.searcheForm.fields.address.value;
					tenderAddresesModel.initSearcheModelByData(0, currentStreet, {
						full: currentAddress,
						id: -1,
					});
				}
			}
		}

		compareTarifficationsModel.setWidgetIsHide();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let {
			ApplicationModel: { modalModel },
		} = this.props;
		if (modalModel.isOpen) {
			modalModel.toggleModal();
		}
	}

	sendData(data) {
		let {
			ApplicationModel: { sendingStore, modalModel, popupModel },
		} = this.props;

		let infoUser = {
			name_popup: "Tender",
		};
		popupModel.setInfoUser(infoUser);

		data = addABData(data);
		data = addRefererData(data, this.props.ApplicationModel);

		sendingStore.onTender(data);
		modalModel.scrollToTop(200, "html");
	}

	render() {
		let {
			ApplicationModel: { sendingStore, tenderAddresesModel, tenderAddressOneStringModel, text },
			location: { search },
		} = this.props;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;
		const siteCode = this.props.ApplicationModel.siteCode;
		if (sendingStore.sendOfficeOrder) {
			let url = generateUrl(Routes.AddReview.route, {
				regionUrl: this.props.match.params.regionUrl,
			});
			let button = (
				<Link to={url}>
					<div style={{ marginBottom: "16px" }}>
						<Button status={"secondaryAccent"} transparent={true} datatest={"give_feedback"}>
							{text.ratingLeaveReview}
						</Button>
					</div>
				</Link>
			);

			return (
				<EmptyStubWrapper
					link={url}
					headerText={text.NEW_WELCOME_TITLE}
					displayText={text.NEW_WELCOME_TEXT}
					classTenderOffice={true}
					iconHeader={"icon-balance"}
					buttonComponent={button}
				/>
			);
		}
		let selectedOptionPlace = 0;
		if (search) {
			let getParam = search.split("?");
			let getParams2 = getParam[1].split("&");
			getParams2.map((item) => {
				let getParam3 = item.split("=");
				if (getParam3[0] == "place") {
					selectedOptionPlace = getParam3[1];
				}
			});
		}
		let radioButtonsForPlace = [
			{
				name: text.BUSINESS_BENEFIT_TO_OFFICE_TITLE,
				datatest: "business_order_ownoffice_button",
			},
			{
				name: text.BUSINESS_BENEFIT_TO_NETWORK_OFFICES_TITLE,
				datatest: "business_order_officenetwork_button",
			},
			{
				name: text.BUSINESS_BENEFIT_TO_BUILDING_TITLE,
				datatest: "business_order_ownbuilding_button",
			},
		];

		let services = [
			{
				name: text.TENDER_INTERNET_SERVICE,
				checked: true,
				id: 0,
				datatest: "business_order_input_services_internet",
			},
			{
				name: text.TENDER_PHONE_SERVICE,
				checked: false,
				id: 1,
				datatest: "business_order_input_services_telephony",
			},
			{
				name: text.TENDER_CLOUD_SERVICE,
				checked: false,
				id: 2,
				datatest: "business_order_input_services_cloud",
			},
			{
				name: text.TENDER_TV_SERVICE,
				checked: false,
				id: 3,
				datatest: "business_order_input_services_tv",
			},
			{
				name: text.TENDER_VIDEO_SERVICE,
				checked: false,
				id: 4,
				datatest: "business_order_input_services_video",
			},
			{
				name: text.TENDER_DATA_CENTER_SERVICE,
				checked: false,
				id: 5,
				datatest: "business_order_input_services_datacentr",
			},
			{
				name: text.TENDER_VPN_SERVICE,
				checked: false,
				id: 6,
				datatest: "business_order_input_services_vpn",
			},
		];

		let radioButtonsForInfo = [
			{
				name: text.BUSINESS_CHANGE_PROVIDER,
				datatest: "business_order_input_services_changeprovider",
			},
			{
				name: text.BUSINESS_BACKUP_CHANNEL,
				datatest: "business_order_input_services_reservecanal",
			},
			{
				name: text.BUSINESS_CONNECT_PROVIDER,
				datatest: "business_order_input_services_wantconnect",
			},
		];

		return (
			<>
				{this.canonical()}
				<Tender
					services={services}
					text={text}
					windowSizes={windowSizes}
					radioButtonsForInfo={radioButtonsForInfo}
					radioButtonsForPlace={radioButtonsForPlace}
					region={this.props.data.region}
					sendData={(data) => this.sendData(data)}
					validateEmail={sendingStore.validateEmail}
					validatePhone={sendingStore.validatePhone}
					tenderModel={tenderAddresesModel}
					tenderOneStringModel={tenderAddressOneStringModel}
					seacheModels={tenderAddresesModel.seacheModels}
					searchOneStringModels={tenderAddressOneStringModel.searchModels}
					selectedOptionPlace={selectedOptionPlace}
					phone={sendingStore.phone}
				/>
			</>
		);
	}
}

export default withRouter(
	withDefaultParams(
		graphql(REGION_QUERY, {
			options: (props) => {
				return {
					variables: {
						filter: `url=${props.match.params.regionUrl}`,
					},
				};
			},
		})(TenderContainer)
	)
);
